// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Attachment = function Attachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.002 2.71a2.667 2.667 0 0 0-3.775 0l-7.698 7.706a4.48 4.48 0 0 0 0 6.341 4.49 4.49 0 0 0 6.342 0l6.094-6.1a.96.96 0 0 1 1.36 0 .963.963 0 0 1 0 1.36l-6.094 6.105a6.405 6.405 0 0 1-9.062 0 6.416 6.416 0 0 1-.004-9.07l7.702-7.706a4.597 4.597 0 0 1 6.499 0 4.597 4.597 0 0 1 0 6.497L9.992 15.22a3.004 3.004 0 0 1-4.473-.249 3.01 3.01 0 0 1 .221-4.005l6.09-6.089a.96.96 0 0 1 1.36 0 .963.963 0 0 1 0 1.36L7.104 12.33a1.077 1.077 0 0 0-.08 1.437 1.076 1.076 0 0 0 1.605.088l7.373-7.372a2.67 2.67 0 0 0 0-3.777z"
  }));
};
